import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { MatchableItem } from "../types";

export const CounterpartyCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => (
        <ViewTableCell>{row.original.counterpartyName ?? ""}</ViewTableCell>
    ),
);
CounterpartyCell.displayName = "CounterpartyCell";
